import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { AlertGetter, AlertState } from "../types";

export const getters: GetterTree<AlertState, RootState> &
  Record<AlertGetter, Getter<AlertState, RootState>> = {
  [AlertGetter.GetShow](state) {
    return state.show;
  },
  [AlertGetter.GetMessage](state) {
    return state.message;
  },
  [AlertGetter.GetAlertType](state) {
    return state.alertType;
  }
};
